import { Injectable } from '@angular/core';
import { Tenant } from '../data-models/tenant';
import { map, take } from 'rxjs/operators';
import { GlobalsService } from './globals.service';
import { HttpClient } from '@angular/common/http';
import { Auth } from '@angular/fire/auth';
import { Database, ref, push, update, get } from '@angular/fire/database';
import { from, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  coreAPI: string = 'https://localhost:44385/api/';
  constructor(private db: Database, public afAuth: Auth, private globals: GlobalsService, private http: HttpClient) {
    this.coreAPI = this.globals.coreAPI;
  }

  // Update an existing tenant
  updateTenant(tenant: Tenant) {
    if (!tenant.key) {
      throw new Error('Tenant key is required for update');
    }
    const tenantRef = ref(this.db, `/Tenants/${tenant.key}`);
    return update(tenantRef, tenant);
  }

  // Fetch tenant by key
  fetchTenant(tenantKey: string): Observable<Tenant> {
    const tenantRef = ref(this.db, `/Tenants/${tenantKey}`);
    return from(get(tenantRef)).pipe(
      map(snapshot => ({ key: tenantKey, ...snapshot.val() } as Tenant))
    );
  }

  createCoreTenant(tenant: Tenant) {
    return this.http.post(this.coreAPI + 'Tenant/CreateTenant', tenant);
  }


  updateCoreTenant(tenant: Tenant) {
    return this.http.post(this.coreAPI + 'Tenant/UpdateTenant', tenant);
  }


}
